import React from "react";
import { HashRouter as Router , Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material';

import { AuthProvider } from './AuthContext';
import PageCalendarView from "./pageCalendarView";
import PageEventEdit from "./pageEventEdit";
import UserLoginForm from "./userLoginForm";
import UserChangePasswordForm from "./userChangePasswordForm";



export default function App() {

  const theme = createTheme({
    components: {
      // Name of the component
      MuiButton: {
        styleOverrides: {
          // Name of the slot
          contained: {
            // contained button
            backgroundColor: '#2C3F50',
            '&:hover': { backgroundColor: '#45627D' }
          },
          outlined: {
            color: '#2C3F50',
            borderColor: '#2C3F50',
            '&:hover': { backgroundColor: '#E5EBF0', borderColor: '#45627D' }
          }
        },
      },
      MuiInputBase: {
      styleOverrides: {
        input: {
          padding: '4px 8px',
          fontSize: '14px',
        },
      },
    },
      MuiAvatar: {
        variants: [
          { props: { className: 'entityType-list' }, style: { backgroundColor: '#2BA0F0', width: '20px', height: '20px', fontSize: '8pt' } }
          , { props: { className: 'entityType-flow' }, style: { backgroundColor: '#2BA0F0', width: '16px', height: '16px', fontSize: '6pt' } }
          , { props: { className: 'userWelcomeStep' }, style: { backgroundColor: '#f1356d', width: '16px', height: '16px', fontSize: '8pt' } }
        ],
      }
    },
  });
  return (
    <AuthProvider>
                <ThemeProvider theme={theme}>
      <Router >
        <Routes>
          <Route path="/" element={<PageCalendarView />} />
          <Route path="/event/:id" element={<PageEventEdit />} />
          <Route path="/userLogin" element={<UserLoginForm />}></Route>
          <Route path="/userChangePassword" element={<UserChangePasswordForm />}></Route>
        </Routes>
      </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}
